<template>
  <card :title="title" titleBottomPadding="8px" id="sc-work-reports" v-if="canEdit || canDelete" v-cloak>
    <SCDailyReportDx ref="dailyReport" />
  </card>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import Forbidden from "~/pages/errors/Forbidden.vue";
import { canDelete, canEdit } from "~/helpers/Permissions";
import SCDailyReportDx from "~/pages/salary-calculator/sc-work-reports/reports/SCDailyReportDx.vue";

export default {
  name: "ScWorkReport",
  components: { SCDailyReportDx, Forbidden },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$t("common.reports");
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
  },
};
</script>
